import _404 from './_404.vue';
import load from './load.vue';
import upImg from './up-img.vue';
import myDownload from './myDownload.vue';
import myInput from './myInput.vue';
import gylHead from './gyl-head.vue';
import gylFooter from './gyl-footer.vue';
import gylFooter2 from './gyl-footer2.vue';
import gylCustom from './Customer.vue';
import gylSort from './gyl-sort.vue';
const component = {
    _404,load,upImg,myDownload,myInput,gylHead,gylFooter,gylCustom,gylFooter2,gylSort
}

export default component;



// WEBPACK FOOTER //
// ./src/components/inc/component/index.js